(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name fuel.service:fuelSuppliersService
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .service('FuelSuppliersService', FuelSuppliersService);

    function FuelSuppliersService(CommonFuelService, FuelRequestFactory, RemoteService) {
        var self = this;

         var model={
            supplierSearchCriteria: FuelRequestFactory.getFuelSuppliersSearchRequest(),
            suppliersList:[]
        };

        self.setSuppliersSearchCriteria = function (searchCriteria) {
            model.supplierSearchCriteria = FuelRequestFactory.getFormattedFuelSuppliersSearchRequest(searchCriteria);
        };

        self.getNewSupplier = function () {
            return FuelRequestFactory.getSupplierForEditor();
        };

        self.setSupplierForEdit = function (supplier) {
            var editorSupplier = FuelRequestFactory.getSupplierForEditor();
            editorSupplier.fuelSupplierId = supplier.fuelSupplierId;
            editorSupplier.companyName = supplier.companyName;
            editorSupplier.companyAbbr = supplier.companyAbbr;
            editorSupplier.status = supplier.status==="INA"?true:false;
            editorSupplier.version = supplier.version;
            editorSupplier.contactData = supplier.contactData;
            editorSupplier.address = supplier.address;
            editorSupplier.city = _.find(CommonFuelService.getCityList(), {"airPortCode":supplier.city});
            return editorSupplier;
        };

        self.getSuppliersSearchCriteria = function () {
            var reformatSearchCriteria = model.supplierSearchCriteria;
            if(model.supplierSearchCriteria.city!==null){
                reformatSearchCriteria.city = _.find(CommonFuelService.getCityList(), {"airPortCode":model.supplierSearchCriteria.city});
            }
            return reformatSearchCriteria;
        };

        self.deleteSelectedSupplier = function (supplier,  successFn, errorFn) {
            var deleteSupplier = FuelRequestFactory.getSupplierForDelete(supplier);
            RemoteService.deleteFuelSupplier(deleteSupplier).then(
                function (response) {
                    if(response.success){
                        successFn(response);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.saveSelectedSupplier = function (supplier, successFn, errorFn) {
            var saveSupplier =FuelRequestFactory.getSupplierForSave(supplier);
            RemoteService.saveFuelSupplier(saveSupplier).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getSuppliers = function(successFn, errorFn){
            //TODO call to RemoteService load suppliers by sending  model.supplierSearchCriteria
            RemoteService.searchFuelSuppliers(model.supplierSearchCriteria).then(
                function (response) {
                    if(response.success && !!response.fuelSupplierInfoCollection){
                        model.suppliersList = FuelRequestFactory.getFormattedSuppliers(response.fuelSupplierInfoCollection);
                        successFn(model.suppliersList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

    }
})();
